import angular from 'angular'

/**
 * A search index for searching for customers by exact customer code match.
 *
 * @module customerCodeIndex
 */
angular
  .module('webregister.factories')
  .factory('customerCodeIndex', function (ExactMatchIndex: $TSFixMe) {
    return ExactMatchIndex.create({
      name: 'customerCodeIndex',
      entityName: 'customer',
      entityStoreName: 'customers',
      databaseIndexName: 'byCustomerCode',
    })
  })
